// extracted by mini-css-extract-plugin
export default {"dateRow":"BoardForm_dateRow__N8KkT","dateLabel":"BoardForm_dateLabel__qISNT","dateInput":"BoardForm_dateInput__kG+ML"};